var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewportWindowLevel = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 1.015a6.985 6.985 0 1 1 0 13.97 6.985 6.985 0 0 1 0-13.97"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.98 6.998A7.773 7.773 0 0 1 7 17.98l1.283-1.283.581-.581.838-.839 1.895-1.895 3.39-3.39Z"
})))));
export { SvgViewportWindowLevel as ReactComponent };
export default __webpack_public_path__ + "assets/images/viewport-window-level.svg";